export default function(value) {
  if (!value) return true;
  if (typeof value !== 'string') return false;
  if (value.match(/[A-Z]\d{6}/)) return true;
  return false;
}
